import { TemplateCardProps } from '../../lib/types';
import { Card } from '../../core/card';

export const TemplateCard = (props: TemplateCardProps) => {
  const { actionRoute, actionLabel } = props;

  const cardProps = {
    ...props,
    actionRoute: actionRoute,
    actionLabel: actionLabel ?? 'Run',
  };

  return (
    <Card.Root {...cardProps}>
      <Card.Card>
        <Card.Title />
        <Card.Content />
        <Card.Actions />
      </Card.Card>
    </Card.Root>
  );
};
